export const keyStorageTheme = 'CoreUiDashboard'
export const toastDefaultPosition = 'bottom-right'
export const toastDefaultDuration = '5000'
export const defaultCoin = 'CHF'
export const defaultFormatToHumanDateFormat = 'fr-CH'
export const defaultLocaleDateString = 'de-CH'
export const availableStatisticsComparisonsTypes = ['CHF', 'qte']
export const availableExportTypes = ['PDF', 'XLS']
